import http from "../utils/http";

const getPoiList = async () => await http.get("/api/area/guide");
const activityList = async (data) => await http.get("/api/area/spot_msg/", data);

const poiDetail = async (id) => await http.get(`/api/area/spot_info/${id}/`)
export {
  getPoiList,
  poiDetail,
  activityList
};
